import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { isNativePlatform } from './platform';

export type ImageSourceOption = 'camera' | 'gallery';

/**
 * Take a photo using the device camera
 */
export const takePhoto = async (): Promise<string | null> => {
  try {
    const image = await Camera.getPhoto({
      quality: 85,
      allowEditing: false,
      resultType: CameraResultType.DataUrl,
      source: CameraSource.Camera,
      correctOrientation: true,
    });
    return image.dataUrl || null;
  } catch (error) {
    console.error('Error taking photo:', error);
    return null;
  }
};

/**
 * Pick a photo from gallery
 */
export const pickFromGallery = async (): Promise<string | null> => {
  try {
    const image = await Camera.getPhoto({
      quality: 85,
      allowEditing: false,
      resultType: CameraResultType.DataUrl,
      source: CameraSource.Photos,
      correctOrientation: true,
    });
    return image.dataUrl || null;
  } catch (error) {
    console.error('Error picking from gallery:', error);
    return null;
  }
};

/**
 * Get image from specified source (camera or gallery)
 */
export const getImageFromSource = async (source: ImageSourceOption): Promise<string | null> => {
  if (source === 'camera') {
    return takePhoto();
  }
  return pickFromGallery();
};

/**
 * Check if native camera is available on current platform
 */
export const isCameraAvailable = (): boolean => {
  return isNativePlatform();
};
